// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/****************** Iternary properties css New*********************/

  .ds_newlanding .ds_banner_new{
    background-image: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Background-Itinerary.jpg);
    position: relative;
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
    background-position: center;
    height: 100vh;
  }

  .ds_newlanding .banner_content{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-top: 5%;
  }
  .ds_newlanding .banner_logo img{
    width: 150px;
  }
  .ds_newlanding .banner_title h1{
    font-size: 24px;
    color: #fff;
    font-weight: 500;
    margin: 20px 0px;
  }
  .ds_newlanding .banner_text h2 {
    font-size: 38px;
    color: #000;
    font-weight: 700;
    margin: 20px 0px;
  }
  .DSitinerary-today{
    padding: 0px;
    text-align: center;
  }
  .ds_newlanding .left-addresblock {
    width: 400px;
  }
  .ds_newlanding .yourItinerary-detail .logo {
    width: 120px;
    text-align: center;
    overflow: hidden;
    height: 80px;
    margin: 0 auto;
  }
  .ds_newlanding .yourItinerary-detail .logo img {
    width: 80px;
  }
  .yourItinerary-detail .user-Detail {
    margin-top: 20px;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #000000;
    padding-bottom: 10px;
  }
  .left-addresblock .user-Detail .username-block h2 {
    font-size: 20px;
    font-weight: 500;
    margin: 20px 0px 10px 0px;
  }
  .left-addresblock .addressblock h3 {
    font-size: 16px;
    margin: 15px 10px;
  }
  .left-addresblock .dsProfile {
    width: 100%;
    overflow: hidden;
    word-wrap: break-word;
    text-align: left;
  }
  .left-addresblock .dsProfileLeft {
    width: 140px;
    height: 140px;
    float: left;
    margin-top: 2.7em;
    margin-left: 10px;
    overflow: hidden;
    border-radius: 100%;
    box-shadow: 4px 2px 18px rgba(0,0,0,.3);
  }
  .left-addresblock .dsProfileLeft img{
    max-width: 100%;
  }
  .left-addresblock .dsProfileRight {
    margin-left: 31%;
  }
  .left-addresblock .dc-detail-block {
    background: #FFF;
    padding: 1.2em 0 1em;
    margin-left: 3em;
  }
  .left-addresblock .dc-addressblock h3 {
    font-size: 14px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .left-addresblock .dcHead {
    background: #000;
    padding:5px 10px;
  }
  .left-addresblock .dcHead h2 {
    margin: 0;
    padding: 0;
    font-size: 13px;
    font-weight: 400;
    color: #FFF;
    display: inline-block;
    cursor: pointer;
  }
  
  .left-addresblock .dc-modal, .left-addresblock .dc-modal-show {
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    transition: all .5s ease-in-out;
  }
  .left-addresblock .dc-modal-show {
    background-color: #fff;
    background-color: rgba(255,255,255,.7);
  }
  .left-addresblock .dc-modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 2px solid #000000;
    width: 55%;
    position: relative;
  }
  .left-addresblock .dc-modal-content:after, 
  .left-addresblock .dc-modal-content:before {
    content: "";
    position: absolute;
    left: 41%;
    border-style: solid;
    display: block;
    width: 0;
  }
  .left-addresblock .dc-modal-content:before {
    bottom: -62px;
    border-width: 60px 50px 0;
    border-color: #db352e transparent;
  }
  .left-addresblock .dc-modal-content:after {
    bottom: -58px;
    border-width: 59px 50px 0;
    border-color: #fff transparent;
  }
  .left-addresblock .dc-close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: 700;
  }
  .left-addresblock .dc-modal-content h2, 
  .left-addresblock .itinerary-row.header {
    color: #000000;
    font-weight: 500;

  }
  .left-addresblock .dc-modal-content h2 {
    font-size: 20px;
    font-style: italic;
    padding-bottom: 10px;
  }
  .left-addresblock .dc-modal-content .pick-thumb, 
  .left-addresblock .dsProfileLeft {
    overflow: hidden;
    border-radius: 100%;
    box-shadow: 4px 2px 18px rgba(0,0,0,.3);
  }
  .left-addresblock .dc-modal-content .pick-thumb {
    width: 150px;
    height: 150px;
    background: #f5f5f5;
    text-align: center;
    margin: 0 auto 20px;
  }
  .left-addresblock .dc-modal-content .dc-list p {
    margin-bottom: 10px;
    font-weight: 100;
    font-style: italic;
    color: #969696;
  }
  .left-addresblock .dc-modal-content h3 {
    color: #000000;
    font-size: 20px;
    font-style: italic;

    font-weight: 500;
  }
  .left-addresblock .dc-modal-content .pick-thumb img{
    max-width: 100%;
  }
  .ds_newlanding .ItineraryMap-block {
    padding: 3em 0;
    padding-top: 0px;
  }
  
  .propertyMapbox-block {
    margin-bottom: 30px;
  }
  .propertyMapbox-block .propertyMapbox-head {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    font-size: 15px;
    justify-content: space-between;
  }
  .propertyMapbox-block .mapbox-pointer {
    background: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Map-Poiter.png);
    width: 29px;
    height: 40px;
    position: relative;
    margin-right: 10px;
    filter: grayscale(1);
  }
  .propertyMapbox-block .mapbox-count {
    color: #333;
    position: absolute;
    top: 5px;
    left: 12px;
    font-size: 11px;
  }
  .propertyMapbox-block .mapbox-address {
    display: flex;
    align-items: center;
    margin-left: 10px;
    font-size: 15px;
  }
  .propertyMapbox-block .propertyMapbox-map {
    border: 1px solid #000000;
    background: #FFF;
    height: 280px;
    overflow: hidden;
  }
  .propertyMapbox-block .propertyMapbox-map img {
    width: 100%;
    height: 100%;
  }
  .ItineraryMap-block a {
    color: #000;
    text-decoration: none;
  }
  .ItineraryList-block{
    padding: 3em 0;
    font-size: 15px;
  }
  .ItineraryList-block .property-listbox-block {
    border-bottom: 1px solid #afafb0;
    margin-bottom: 5px;
    padding-bottom: 5px;
  }
  .property-listbox-block .property-listbox-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .property-listbox-block .propertyMaplist-block {
    display: flex;
    align-items: center;
    width: 60%;
  }
  .property-listbox-block .propertyMaplist-block_first-c{
    display: flex;
    align-items: center;
  }
  .property-listbox-block .mapbox-pointer {
    background: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Map-Poiter.png);
    width: 29px;
    height: 40px;
    position: relative;
    margin-right: 10px;
    margin-left: 10px;
    filter: grayscale(1);
  }
  .property-listbox-block .mapbox-count {
    color: #333;
    position: absolute;
    top: 5px;
    left: 12px;
    font-size: 11px;
  }
  .property-listbox-block .propertyMaplist-image-block {
    border: 1px solid #000000;
    width: 200px;
    height: 140px;
    overflow: hidden;
    margin-left: 10px;
  }

  .property-listbox-block .propertyMaplist-image-block img{
    max-width: 100%;
    max-height: 100%;
    min-height: 140px;
    min-width: 200px;
  }
  .property-listbox-block .propertyMaplist-address-block {
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    min-height: 140px;
    justify-content: space-between;

  }
  .property-listbox-block .propertyMaplist-address-block h1 {
    font-size: 20px;
    margin-bottom: 5px;
    margin-top: 0;
  }
  .property-listbox-block .propertyMaplist-address-block p {
    margin-bottom: 0;
    font-size: 15px;
  }
  .property-listbox-block .propertyMaplist-rating-block {
    display: flex;
    align-items: center;
    width: 35%;
  }
  .property-listbox-block .rating-block {
    display: flex;
    flex-direction: column;
  }
  .property-listbox-block .property-rate-head {
    margin-bottom: 5px;
  }
  .property-listbox-block .rating-num-block ul {
    display: flex;
    margin: 0;
    padding: 0;
  }
  .property-listbox-block .rating-num-block ul li {
    margin: 0 3px;
    background: #fff;
    color: #000;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    position: relative;
    cursor: pointer;
    -webkit-transition: all .35s;
    -moz-transition: all .35s;
    transition: all .35s;
  
  }
  .property-listbox-block .font-blod {
    font-weight: 500;
  }
  .property-listbox-block .rating-disc {
    margin-left: 20px;
  }
  .property-listbox-block .form-control {
    border: 0;
    width: 100%;
    resize: none;
    font-size: 15px;
    background: #f5f5f5;
  }
  
  @media screen and (max-width: 767px){
  .property-listbox-flex {
    flex-direction: column;
    align-items: flex-start;
  }
  }
  
  .ds_newlanding .left-addresblock{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .left-addresblock .dsProfile{
   width: 45%;
   position: relative;
   overflow: initial;
  }
  .left-addresblock .dsProfile:first-child::after{
    position: absolute;
    content: "";
    width: 2px;
    height: 100%;
    background: #e0e0e0;
    top: 0px;
    right: -10%;
  }
  .iternary-btn{
    border: 0px;
    padding: 10px 20px;
    border-radius: 5px;
    
    font-weight: 400;
    line-height: 15px;
    background: transparent;
    color: #030c11;
    font-size: 19px;
    font-weight: 500;
    text-decoration: underline;
    padding-left: 0px;
  }
  


.sch_appointments .top h1{
  text-align: center;
  color: #000000;
  font-size: 35px;
  margin: 0px;
  font-weight: 700;
}
.sch_appointments .top h2{
  text-align: center;
  font-size: 23px;
  color: #444;
  margin-bottom: 5px;
}
.sch_appointments .top h2 span{
  color: #1e81bb;
}
.sch_appointments .top h3{
  text-align: center;
  font-size: 18px;
  font-style: italic;
  color: #5a5a5a;
  font-weight: 100;
  margin: 0px;
}
.sch_appointments_thumbs{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 25px;
  grid-row-gap: 25px;
  margin-top: 20px;
}
.sch_appointments_thumbs .item{
  background: #FFFFFF;
    padding: 30px;
    border-radius: 20px;
    text-align: center;
    min-height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    box-shadow: 0px 0px 4px #b7b7b7;
}


.sch_appointments_thumbs .item b{
  background: #000000;
  width: 30px;
  display: inline-block;
  text-align: center;
  height: 30px;
  color: #ffffff;
  border-radius: 50%;
  line-height: 30px;
  font-weight: 400;
  
}
.sch_appointments_thumbs .item h1{
  color: #1e81bb;
  font-size: 25px;
  font-weight: 400;
  padding: 30px 0px 15px 0;
  
 margin-bottom: 0px;
}
.sch_appointments_thumbs .item h1 i{
  font-size: 21px;
  position: relative;
  top: -2px;
  
}
.sch_appointments_thumbs .item ul{
  padding: 0px;
  margin: 0px;
  list-style-type: none;
}
.sch_appointments_thumbs .item ul li{
  display: inline-block;
  font-size: 16px;
  border-right: 2px solid #000000;
  line-height: 21px;
  margin: 0;
  padding: 0px 15px;
}
.sch_appointments_thumbs .item ul li:last-child{
  border: 0px;
}
.sch_appointments_thumbs .item h2{
  color: #000000;
  font-style: italic;
  font-size: 17px;
  
  margin-bottom: 0px;

}
.sch_appointments_thumbs .item p{
  font-size: 19px;
  margin: 0px;
  color: #444444;
  
}
.sch_appointments_thumbs .item p i{
  color: #000000;
}
.ds_newlanding .sch_appointments_thumbs{
  display: block;
  margin-top: 0px;
}
.ds_newlanding .sch_appointments_thumbs .item{
  background: transparent;
  padding: 0px;
  margin-bottom: 30px;
  border: 0px;
}
.ds_newlanding .sch_appointments_thumbs .item h1{
  padding-top: 0px;
  color: #000000;
}
.sch_intinery_back{
  text-align: left;
  position: fixed;
  left: 0;
  top: 93px;
  background: #dedede;
  padding: 8px 20px;
  color: #07151f;
  font-size: 15px;
  z-index: 999;
  font-weight: 400;
  cursor: pointer;
}
.sch_intinery_back i{
  padding-right: 5px;
}
.sch_appointments_thumbs .item p.view-more{
  position: relative;
  bottom: -15px;
}
.sch_appointments_thumbs .item p.view-more a{
  color: #1e81bb;  
    font-weight: 500;
}




@media (max-width:1366px){
  .sch_appointments .top h1{
    font-size: 25px;
  }
  .sch_appointments .top h2{
    font-size: 17px;
  }
  .sch_appointments .top h3{
    font-size: 15px;
  }
  .sch_appointments_thumbs .item h1{
    font-size: 22px;
    padding: 20px 0px 10px 0;
  }
  .sch_appointments_thumbs .item h1 i{
    font-size: 17px;
  }
  .sch_appointments_thumbs .item ul li{
    font-size: 16px;
  }
  .sch_appointments_thumbs .item h2{
    font-size: 13px;
  }
  .sch_appointments_thumbs .item p{
    font-size: 15px;
  }

}

@media (max-width:1200px){
  .property-listbox-block .propertyMaplist-block{
    width: 75%;
  }
  .property-listbox-block .propertyMaplist-rating-block{
    width: 25%;
  }
  .sch_appointments_thumbs .item h1{
    font-size: 17px;
  }
  .sch_appointments_thumbs .item h1 i {
    font-size: 14px;
    top: -1px;
  }
  .sch_appointments_thumbs .item ul li {
    font-size: 14px;
    line-height: 14px;
  }
  .sch_appointments_thumbs .item h2 {
    font-size: 11px;
  }
  .sch_appointments_thumbs .item p {
    font-size: 13px;
  }
}

@media (max-width:991px){
  .sch_appointments_thumbs{
    grid-template-columns: repeat(1, 1fr);
  }
  .sch_appointments_thumbs .item{
      padding: 30px;
  }
  .sch_appointments_thumbs .item h1{
      padding: 15px 0px 5px 0;
      font-size: 21px;
      margin-bottom: 0px;
  }
  .sch_appointments_thumbs .item h1 i {
      font-size: 16px;
      position: relative;
      top: -1px;
  }
  .sch_appointments_thumbs .item ul li {
      font-size: 16px;
      line-height: 16px;
      padding: 0px 5px;
  }
  .sch_appointments_thumbs .item p {
      font-size: 16px;
  }
  .property-listbox-block .mapbox-pointer{
    margin: 0px;
  }
  .property-listbox-block .propertyMaplist-address-block{
    width: 200px;
  }
  .property-listbox-block .propertyMaplist-address-block p{
    font-size: 12px;
  }
  .property-listbox-block .propertyMaplist-address-block h1{
    font-size: 17px;
  }
  
  .propertyMapbox-block .mapbox-address span{
    flex-grow: unset;
    font-size: 13px;
    width: 200px;
  }
  .propertyMapbox-block .mapbox-time{
    font-size: 12px;
    font-weight: 600;
  }
  .propertyMapbox-block .propertyMapbox-map{
    height: 220px;
  }
  
}

@media (max-width:767px){
  
  .propertyMapbox-block .propertyMapbox-map {
    height: auto;
  }
  .propertyMapbox-block .mapbox-address span {
    font-size: 15px;
    width: auto;
  }
  .propertyMapbox-block .mapbox-time {
    font-size: 15px;
    font-weight: 400;
  }
  .property-listbox-block .propertyMaplist-block {
    width: 100%;
  }
  .property-listbox-block .propertyMaplist-rating-block{
    width: 100%;
    margin-top: 20px;
    margin-bottom: 15px;
  }
  .sch_appointments_thumbs .item b {
    background: #e1251b;
    width: 25px;
    display: inline-block;
    text-align: center;
    height: 25px;
    color: #ffffff;
    border-radius: 50%;
    line-height: 25px;
    font-weight: 400;
    
    font-size: 12px;
  }
  .propertyMapbox-block .mapbox-address .mapbox-count span{
    font-size: 12px;
    line-height: 17px;
  }
  .propertyMapbox-block .mapbox-address{
    margin-left: 0px;
  }
}

@media(max-width:510px){
  .property-listbox-block .propertyMaplist-block {
   flex-direction: column;
   align-items: flex-start;
  }
  .property-listbox-block .propertyMaplist-rating-block{
    width: 100%;
    margin-top: 20px;
    margin-bottom: 15px;
  }
  .property-listbox-block .propertyMaplist-address-block{
    width: 100%;
    margin-top: 15px;
    min-height: auto;
    margin-left: 0px;
  }
  .property-listbox-block .rating-block {
    margin-top: 15px;
  }
  .sch_appointments_thumbs .item {
    padding: 15px 5px;
  }
  .sch_appointments_thumbs .item h1 {
    font-size: 17px;
  }
  .sch_appointments_thumbs .item h1 i {
    font-size: 14px;
    top: -1px;
  }
  .sch_appointments_thumbs .item ul li {
    font-size: 14px;
    line-height: 16px;
    padding: 2px 5px;
    display: block;
    border: 0;
    color: #929292;
    font-weight: 400;
  }
  .sch_appointments_thumbs .item p {
    font-size: 13px;
  }
  .propertyMapbox-block .mapbox-pointer{
    position: relative;
    margin-right: 5px;
    width: 22px;
    height: 30px;
    background-size: cover;
    text-align: center;
    min-width: 22px;
  }
  .propertyMapbox-block .mapbox-count {
    color: #333;
    position: absolute;
    top: 2px;
    left: 8px;
    font-size: 5px;
    text-align: center;
  }
  .propertyMapbox-block .mapbox-address .mapbox-count span {
    font-size: 10px;
    line-height: 17px;
    font-weight: 600;
    text-align: center;
  }
  .propertyMapbox-block .mapbox-address span {
    font-size: 11px;
    width: auto;
    line-height: 14px;
  }
  .propertyMapbox-block .mapbox-time {
    font-size: 11px;
    font-weight: 400;
    min-width: 60px !important;
    margin-left: 10px;
  }
  .property-listbox-block .mapbox-pointer {
    position: relative;
    margin-right: 5px;
    width: 22px;
    height: 30px;
    background-size: cover;
    text-align: center;
    min-width: 22px;
  }
  .property-listbox-block  .mapbox-count {
    color: #333;
    position: absolute;
    top: 2px;
    left: 8px;
    font-size: 5px;
    text-align: center;
  }
  .property-listbox-block .mapbox-count span {
    font-size: 10px;
    line-height: 17px;
    font-weight: 600;
    text-align: center;
  }
}


/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.5);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 50px;
  height: 50px;
  margin-top: -0.5em;

  border: 5px solid rgba(33, 150, 243, 1.0);
  border-radius: 100%;
  border-bottom-color: transparent;
  -webkit-animation: spinner 1s linear 0s infinite;
  animation: spinner 1s linear 0s infinite;


}
.property-listbox-block  .rating-num-block .rating{
  background-color: red;
}
.ItineraryList-block .bottom_line h1{
  
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
}

.ItineraryList-block .bottom_line .btn{
    background: #e43226;
    color: #ffffff;
    
    font-size: 15px;
    border-radius: 20px !important;
    padding: 4px 30px;
    font-weight: 500;
    margin-right: 15px;
    margin-top: 70px;
    text-transform: uppercase;
    border: 2px solid #e43226;
}
.ItineraryList-block .bottom_line .btn:hover{
  background: #fff;
  color: #e43226;
  transition: All 0.5s;
}
.sch_appointments_thumbs.viewmore .item{ box-shadow: none; }`, "",{"version":3,"sources":["webpack://./app/pages/Transferee/dsProfile/iternaryProperties.css"],"names":[],"mappings":";AACA,oEAAoE;;EAElE;IACE,yJAAyJ;IACzJ,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,gCAAgC;IAChC,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;EACjC;EACA;IACE,sBAAsB;IACtB,sCAAsC;EACxC;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,kBAAkB;EACpB;EACA;;IAEE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,QAAQ;EACV;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,cAAc;IACd,gBAAgB;;EAElB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;;IAElB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,yIAAyI;IACzI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,yIAAyI;IACzI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,8BAA8B;;EAEhC;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,yBAAyB;IACzB,oBAAoB;;EAEtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;EACA;GACC,UAAU;GACV,kBAAkB;GAClB,iBAAiB;EAClB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;;IAElB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;EACnB;;;;AAIF;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;AACnC;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;;AAElB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;;CAEzB,kBAAkB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;;AAEX;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;;EAEf,kBAAkB;;AAEpB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;;AAEhB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;IACZ,gBAAgB;AACpB;;;;;AAKA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;MACI,aAAa;EACjB;EACA;MACI,uBAAuB;MACvB,eAAe;MACf,kBAAkB;EACtB;EACA;MACI,eAAe;MACf,kBAAkB;MAClB,SAAS;EACb;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,gBAAgB;EACpB;EACA;MACI,eAAe;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;;IAEhB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;GACC,sBAAsB;GACtB,uBAAuB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;;AAGA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,yCAAyC;EACzC,mBAAmB;EACnB,gCAAgC;EAChC,gDAAgD;EAChD,wCAAwC;;;AAG1C;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;;IAEd,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA,yCAAyC,gBAAgB,EAAE","sourcesContent":["\n/****************** Iternary properties css New*********************/\n\n  .ds_newlanding .ds_banner_new{\n    background-image: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Background-Itinerary.jpg);\n    position: relative;\n    width: 100%;\n    -webkit-background-size: cover;\n    -moz-background-size: cover;\n    background-size: cover;\n    -o-background-size: cover;\n    background-position: center;\n    height: 100vh;\n  }\n\n  .ds_newlanding .banner_content{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 5%;\n  }\n  .ds_newlanding .banner_logo img{\n    width: 150px;\n  }\n  .ds_newlanding .banner_title h1{\n    font-size: 24px;\n    color: #fff;\n    font-weight: 500;\n    margin: 20px 0px;\n  }\n  .ds_newlanding .banner_text h2 {\n    font-size: 38px;\n    color: #000;\n    font-weight: 700;\n    margin: 20px 0px;\n  }\n  .DSitinerary-today{\n    padding: 0px;\n    text-align: center;\n  }\n  .ds_newlanding .left-addresblock {\n    width: 400px;\n  }\n  .ds_newlanding .yourItinerary-detail .logo {\n    width: 120px;\n    text-align: center;\n    overflow: hidden;\n    height: 80px;\n    margin: 0 auto;\n  }\n  .ds_newlanding .yourItinerary-detail .logo img {\n    width: 80px;\n  }\n  .yourItinerary-detail .user-Detail {\n    margin-top: 20px;\n    border-top: 1px solid #000000;\n    border-bottom: 1px solid #000000;\n    padding-bottom: 10px;\n  }\n  .left-addresblock .user-Detail .username-block h2 {\n    font-size: 20px;\n    font-weight: 500;\n    margin: 20px 0px 10px 0px;\n  }\n  .left-addresblock .addressblock h3 {\n    font-size: 16px;\n    margin: 15px 10px;\n  }\n  .left-addresblock .dsProfile {\n    width: 100%;\n    overflow: hidden;\n    word-wrap: break-word;\n    text-align: left;\n  }\n  .left-addresblock .dsProfileLeft {\n    width: 140px;\n    height: 140px;\n    float: left;\n    margin-top: 2.7em;\n    margin-left: 10px;\n    overflow: hidden;\n    border-radius: 100%;\n    box-shadow: 4px 2px 18px rgba(0,0,0,.3);\n  }\n  .left-addresblock .dsProfileLeft img{\n    max-width: 100%;\n  }\n  .left-addresblock .dsProfileRight {\n    margin-left: 31%;\n  }\n  .left-addresblock .dc-detail-block {\n    background: #FFF;\n    padding: 1.2em 0 1em;\n    margin-left: 3em;\n  }\n  .left-addresblock .dc-addressblock h3 {\n    font-size: 14px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n  .left-addresblock .dcHead {\n    background: #000;\n    padding:5px 10px;\n  }\n  .left-addresblock .dcHead h2 {\n    margin: 0;\n    padding: 0;\n    font-size: 13px;\n    font-weight: 400;\n    color: #FFF;\n    display: inline-block;\n    cursor: pointer;\n  }\n  \n  .left-addresblock .dc-modal, .left-addresblock .dc-modal-show {\n    position: fixed;\n    z-index: 1;\n    padding-top: 100px;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    transition: all .5s ease-in-out;\n  }\n  .left-addresblock .dc-modal-show {\n    background-color: #fff;\n    background-color: rgba(255,255,255,.7);\n  }\n  .left-addresblock .dc-modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 2px solid #000000;\n    width: 55%;\n    position: relative;\n  }\n  .left-addresblock .dc-modal-content:after, \n  .left-addresblock .dc-modal-content:before {\n    content: \"\";\n    position: absolute;\n    left: 41%;\n    border-style: solid;\n    display: block;\n    width: 0;\n  }\n  .left-addresblock .dc-modal-content:before {\n    bottom: -62px;\n    border-width: 60px 50px 0;\n    border-color: #db352e transparent;\n  }\n  .left-addresblock .dc-modal-content:after {\n    bottom: -58px;\n    border-width: 59px 50px 0;\n    border-color: #fff transparent;\n  }\n  .left-addresblock .dc-close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: 700;\n  }\n  .left-addresblock .dc-modal-content h2, \n  .left-addresblock .itinerary-row.header {\n    color: #000000;\n    font-weight: 500;\n\n  }\n  .left-addresblock .dc-modal-content h2 {\n    font-size: 20px;\n    font-style: italic;\n    padding-bottom: 10px;\n  }\n  .left-addresblock .dc-modal-content .pick-thumb, \n  .left-addresblock .dsProfileLeft {\n    overflow: hidden;\n    border-radius: 100%;\n    box-shadow: 4px 2px 18px rgba(0,0,0,.3);\n  }\n  .left-addresblock .dc-modal-content .pick-thumb {\n    width: 150px;\n    height: 150px;\n    background: #f5f5f5;\n    text-align: center;\n    margin: 0 auto 20px;\n  }\n  .left-addresblock .dc-modal-content .dc-list p {\n    margin-bottom: 10px;\n    font-weight: 100;\n    font-style: italic;\n    color: #969696;\n  }\n  .left-addresblock .dc-modal-content h3 {\n    color: #000000;\n    font-size: 20px;\n    font-style: italic;\n\n    font-weight: 500;\n  }\n  .left-addresblock .dc-modal-content .pick-thumb img{\n    max-width: 100%;\n  }\n  .ds_newlanding .ItineraryMap-block {\n    padding: 3em 0;\n    padding-top: 0px;\n  }\n  \n  .propertyMapbox-block {\n    margin-bottom: 30px;\n  }\n  .propertyMapbox-block .propertyMapbox-head {\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    font-size: 15px;\n    justify-content: space-between;\n  }\n  .propertyMapbox-block .mapbox-pointer {\n    background: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Map-Poiter.png);\n    width: 29px;\n    height: 40px;\n    position: relative;\n    margin-right: 10px;\n    filter: grayscale(1);\n  }\n  .propertyMapbox-block .mapbox-count {\n    color: #333;\n    position: absolute;\n    top: 5px;\n    left: 12px;\n    font-size: 11px;\n  }\n  .propertyMapbox-block .mapbox-address {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n    font-size: 15px;\n  }\n  .propertyMapbox-block .propertyMapbox-map {\n    border: 1px solid #000000;\n    background: #FFF;\n    height: 280px;\n    overflow: hidden;\n  }\n  .propertyMapbox-block .propertyMapbox-map img {\n    width: 100%;\n    height: 100%;\n  }\n  .ItineraryMap-block a {\n    color: #000;\n    text-decoration: none;\n  }\n  .ItineraryList-block{\n    padding: 3em 0;\n    font-size: 15px;\n  }\n  .ItineraryList-block .property-listbox-block {\n    border-bottom: 1px solid #afafb0;\n    margin-bottom: 5px;\n    padding-bottom: 5px;\n  }\n  .property-listbox-block .property-listbox-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .property-listbox-block .propertyMaplist-block {\n    display: flex;\n    align-items: center;\n    width: 60%;\n  }\n  .property-listbox-block .propertyMaplist-block_first-c{\n    display: flex;\n    align-items: center;\n  }\n  .property-listbox-block .mapbox-pointer {\n    background: url(https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAmerica-Destination-Services-Map-Poiter.png);\n    width: 29px;\n    height: 40px;\n    position: relative;\n    margin-right: 10px;\n    margin-left: 10px;\n    filter: grayscale(1);\n  }\n  .property-listbox-block .mapbox-count {\n    color: #333;\n    position: absolute;\n    top: 5px;\n    left: 12px;\n    font-size: 11px;\n  }\n  .property-listbox-block .propertyMaplist-image-block {\n    border: 1px solid #000000;\n    width: 200px;\n    height: 140px;\n    overflow: hidden;\n    margin-left: 10px;\n  }\n\n  .property-listbox-block .propertyMaplist-image-block img{\n    max-width: 100%;\n    max-height: 100%;\n    min-height: 140px;\n    min-width: 200px;\n  }\n  .property-listbox-block .propertyMaplist-address-block {\n    margin-left: 15px;\n    display: flex;\n    flex-direction: column;\n    min-height: 140px;\n    justify-content: space-between;\n\n  }\n  .property-listbox-block .propertyMaplist-address-block h1 {\n    font-size: 20px;\n    margin-bottom: 5px;\n    margin-top: 0;\n  }\n  .property-listbox-block .propertyMaplist-address-block p {\n    margin-bottom: 0;\n    font-size: 15px;\n  }\n  .property-listbox-block .propertyMaplist-rating-block {\n    display: flex;\n    align-items: center;\n    width: 35%;\n  }\n  .property-listbox-block .rating-block {\n    display: flex;\n    flex-direction: column;\n  }\n  .property-listbox-block .property-rate-head {\n    margin-bottom: 5px;\n  }\n  .property-listbox-block .rating-num-block ul {\n    display: flex;\n    margin: 0;\n    padding: 0;\n  }\n  .property-listbox-block .rating-num-block ul li {\n    margin: 0 3px;\n    background: #fff;\n    color: #000;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    position: relative;\n    cursor: pointer;\n    -webkit-transition: all .35s;\n    -moz-transition: all .35s;\n    transition: all .35s;\n  \n  }\n  .property-listbox-block .font-blod {\n    font-weight: 500;\n  }\n  .property-listbox-block .rating-disc {\n    margin-left: 20px;\n  }\n  .property-listbox-block .form-control {\n    border: 0;\n    width: 100%;\n    resize: none;\n    font-size: 15px;\n    background: #f5f5f5;\n  }\n  \n  @media screen and (max-width: 767px){\n  .property-listbox-flex {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  }\n  \n  .ds_newlanding .left-addresblock{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .left-addresblock .dsProfile{\n   width: 45%;\n   position: relative;\n   overflow: initial;\n  }\n  .left-addresblock .dsProfile:first-child::after{\n    position: absolute;\n    content: \"\";\n    width: 2px;\n    height: 100%;\n    background: #e0e0e0;\n    top: 0px;\n    right: -10%;\n  }\n  .iternary-btn{\n    border: 0px;\n    padding: 10px 20px;\n    border-radius: 5px;\n    \n    font-weight: 400;\n    line-height: 15px;\n    background: transparent;\n    color: #030c11;\n    font-size: 19px;\n    font-weight: 500;\n    text-decoration: underline;\n    padding-left: 0px;\n  }\n  \n\n\n.sch_appointments .top h1{\n  text-align: center;\n  color: #000000;\n  font-size: 35px;\n  margin: 0px;\n  font-weight: 700;\n}\n.sch_appointments .top h2{\n  text-align: center;\n  font-size: 23px;\n  color: #444;\n  margin-bottom: 5px;\n}\n.sch_appointments .top h2 span{\n  color: #1e81bb;\n}\n.sch_appointments .top h3{\n  text-align: center;\n  font-size: 18px;\n  font-style: italic;\n  color: #5a5a5a;\n  font-weight: 100;\n  margin: 0px;\n}\n.sch_appointments_thumbs{\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 25px;\n  grid-row-gap: 25px;\n  margin-top: 20px;\n}\n.sch_appointments_thumbs .item{\n  background: #FFFFFF;\n    padding: 30px;\n    border-radius: 20px;\n    text-align: center;\n    min-height: 100px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: column;\n    box-shadow: 0px 0px 4px #b7b7b7;\n}\n\n\n.sch_appointments_thumbs .item b{\n  background: #000000;\n  width: 30px;\n  display: inline-block;\n  text-align: center;\n  height: 30px;\n  color: #ffffff;\n  border-radius: 50%;\n  line-height: 30px;\n  font-weight: 400;\n  \n}\n.sch_appointments_thumbs .item h1{\n  color: #1e81bb;\n  font-size: 25px;\n  font-weight: 400;\n  padding: 30px 0px 15px 0;\n  \n margin-bottom: 0px;\n}\n.sch_appointments_thumbs .item h1 i{\n  font-size: 21px;\n  position: relative;\n  top: -2px;\n  \n}\n.sch_appointments_thumbs .item ul{\n  padding: 0px;\n  margin: 0px;\n  list-style-type: none;\n}\n.sch_appointments_thumbs .item ul li{\n  display: inline-block;\n  font-size: 16px;\n  border-right: 2px solid #000000;\n  line-height: 21px;\n  margin: 0;\n  padding: 0px 15px;\n}\n.sch_appointments_thumbs .item ul li:last-child{\n  border: 0px;\n}\n.sch_appointments_thumbs .item h2{\n  color: #000000;\n  font-style: italic;\n  font-size: 17px;\n  \n  margin-bottom: 0px;\n\n}\n.sch_appointments_thumbs .item p{\n  font-size: 19px;\n  margin: 0px;\n  color: #444444;\n  \n}\n.sch_appointments_thumbs .item p i{\n  color: #000000;\n}\n.ds_newlanding .sch_appointments_thumbs{\n  display: block;\n  margin-top: 0px;\n}\n.ds_newlanding .sch_appointments_thumbs .item{\n  background: transparent;\n  padding: 0px;\n  margin-bottom: 30px;\n  border: 0px;\n}\n.ds_newlanding .sch_appointments_thumbs .item h1{\n  padding-top: 0px;\n  color: #000000;\n}\n.sch_intinery_back{\n  text-align: left;\n  position: fixed;\n  left: 0;\n  top: 93px;\n  background: #dedede;\n  padding: 8px 20px;\n  color: #07151f;\n  font-size: 15px;\n  z-index: 999;\n  font-weight: 400;\n  cursor: pointer;\n}\n.sch_intinery_back i{\n  padding-right: 5px;\n}\n.sch_appointments_thumbs .item p.view-more{\n  position: relative;\n  bottom: -15px;\n}\n.sch_appointments_thumbs .item p.view-more a{\n  color: #1e81bb;  \n    font-weight: 500;\n}\n\n\n\n\n@media (max-width:1366px){\n  .sch_appointments .top h1{\n    font-size: 25px;\n  }\n  .sch_appointments .top h2{\n    font-size: 17px;\n  }\n  .sch_appointments .top h3{\n    font-size: 15px;\n  }\n  .sch_appointments_thumbs .item h1{\n    font-size: 22px;\n    padding: 20px 0px 10px 0;\n  }\n  .sch_appointments_thumbs .item h1 i{\n    font-size: 17px;\n  }\n  .sch_appointments_thumbs .item ul li{\n    font-size: 16px;\n  }\n  .sch_appointments_thumbs .item h2{\n    font-size: 13px;\n  }\n  .sch_appointments_thumbs .item p{\n    font-size: 15px;\n  }\n\n}\n\n@media (max-width:1200px){\n  .property-listbox-block .propertyMaplist-block{\n    width: 75%;\n  }\n  .property-listbox-block .propertyMaplist-rating-block{\n    width: 25%;\n  }\n  .sch_appointments_thumbs .item h1{\n    font-size: 17px;\n  }\n  .sch_appointments_thumbs .item h1 i {\n    font-size: 14px;\n    top: -1px;\n  }\n  .sch_appointments_thumbs .item ul li {\n    font-size: 14px;\n    line-height: 14px;\n  }\n  .sch_appointments_thumbs .item h2 {\n    font-size: 11px;\n  }\n  .sch_appointments_thumbs .item p {\n    font-size: 13px;\n  }\n}\n\n@media (max-width:991px){\n  .sch_appointments_thumbs{\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .sch_appointments_thumbs .item{\n      padding: 30px;\n  }\n  .sch_appointments_thumbs .item h1{\n      padding: 15px 0px 5px 0;\n      font-size: 21px;\n      margin-bottom: 0px;\n  }\n  .sch_appointments_thumbs .item h1 i {\n      font-size: 16px;\n      position: relative;\n      top: -1px;\n  }\n  .sch_appointments_thumbs .item ul li {\n      font-size: 16px;\n      line-height: 16px;\n      padding: 0px 5px;\n  }\n  .sch_appointments_thumbs .item p {\n      font-size: 16px;\n  }\n  .property-listbox-block .mapbox-pointer{\n    margin: 0px;\n  }\n  .property-listbox-block .propertyMaplist-address-block{\n    width: 200px;\n  }\n  .property-listbox-block .propertyMaplist-address-block p{\n    font-size: 12px;\n  }\n  .property-listbox-block .propertyMaplist-address-block h1{\n    font-size: 17px;\n  }\n  \n  .propertyMapbox-block .mapbox-address span{\n    flex-grow: unset;\n    font-size: 13px;\n    width: 200px;\n  }\n  .propertyMapbox-block .mapbox-time{\n    font-size: 12px;\n    font-weight: 600;\n  }\n  .propertyMapbox-block .propertyMapbox-map{\n    height: 220px;\n  }\n  \n}\n\n@media (max-width:767px){\n  \n  .propertyMapbox-block .propertyMapbox-map {\n    height: auto;\n  }\n  .propertyMapbox-block .mapbox-address span {\n    font-size: 15px;\n    width: auto;\n  }\n  .propertyMapbox-block .mapbox-time {\n    font-size: 15px;\n    font-weight: 400;\n  }\n  .property-listbox-block .propertyMaplist-block {\n    width: 100%;\n  }\n  .property-listbox-block .propertyMaplist-rating-block{\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 15px;\n  }\n  .sch_appointments_thumbs .item b {\n    background: #e1251b;\n    width: 25px;\n    display: inline-block;\n    text-align: center;\n    height: 25px;\n    color: #ffffff;\n    border-radius: 50%;\n    line-height: 25px;\n    font-weight: 400;\n    \n    font-size: 12px;\n  }\n  .propertyMapbox-block .mapbox-address .mapbox-count span{\n    font-size: 12px;\n    line-height: 17px;\n  }\n  .propertyMapbox-block .mapbox-address{\n    margin-left: 0px;\n  }\n}\n\n@media(max-width:510px){\n  .property-listbox-block .propertyMaplist-block {\n   flex-direction: column;\n   align-items: flex-start;\n  }\n  .property-listbox-block .propertyMaplist-rating-block{\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 15px;\n  }\n  .property-listbox-block .propertyMaplist-address-block{\n    width: 100%;\n    margin-top: 15px;\n    min-height: auto;\n    margin-left: 0px;\n  }\n  .property-listbox-block .rating-block {\n    margin-top: 15px;\n  }\n  .sch_appointments_thumbs .item {\n    padding: 15px 5px;\n  }\n  .sch_appointments_thumbs .item h1 {\n    font-size: 17px;\n  }\n  .sch_appointments_thumbs .item h1 i {\n    font-size: 14px;\n    top: -1px;\n  }\n  .sch_appointments_thumbs .item ul li {\n    font-size: 14px;\n    line-height: 16px;\n    padding: 2px 5px;\n    display: block;\n    border: 0;\n    color: #929292;\n    font-weight: 400;\n  }\n  .sch_appointments_thumbs .item p {\n    font-size: 13px;\n  }\n  .propertyMapbox-block .mapbox-pointer{\n    position: relative;\n    margin-right: 5px;\n    width: 22px;\n    height: 30px;\n    background-size: cover;\n    text-align: center;\n    min-width: 22px;\n  }\n  .propertyMapbox-block .mapbox-count {\n    color: #333;\n    position: absolute;\n    top: 2px;\n    left: 8px;\n    font-size: 5px;\n    text-align: center;\n  }\n  .propertyMapbox-block .mapbox-address .mapbox-count span {\n    font-size: 10px;\n    line-height: 17px;\n    font-weight: 600;\n    text-align: center;\n  }\n  .propertyMapbox-block .mapbox-address span {\n    font-size: 11px;\n    width: auto;\n    line-height: 14px;\n  }\n  .propertyMapbox-block .mapbox-time {\n    font-size: 11px;\n    font-weight: 400;\n    min-width: 60px !important;\n    margin-left: 10px;\n  }\n  .property-listbox-block .mapbox-pointer {\n    position: relative;\n    margin-right: 5px;\n    width: 22px;\n    height: 30px;\n    background-size: cover;\n    text-align: center;\n    min-width: 22px;\n  }\n  .property-listbox-block  .mapbox-count {\n    color: #333;\n    position: absolute;\n    top: 2px;\n    left: 8px;\n    font-size: 5px;\n    text-align: center;\n  }\n  .property-listbox-block .mapbox-count span {\n    font-size: 10px;\n    line-height: 17px;\n    font-weight: 600;\n    text-align: center;\n  }\n}\n\n\n/* Absolute Center Spinner */\n.loading {\n  position: fixed;\n  z-index: 999;\n  overflow: show;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 50px;\n  height: 50px;\n}\n\n/* Transparent Overlay */\n.loading:before {\n  content: '';\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255,255,255,0.5);\n}\n\n/* :not(:required) hides these rules from IE9 and below */\n.loading:not(:required) {\n  /* hide \"loading...\" text */\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.loading:not(:required):after {\n  content: '';\n  display: block;\n  font-size: 10px;\n  width: 50px;\n  height: 50px;\n  margin-top: -0.5em;\n\n  border: 5px solid rgba(33, 150, 243, 1.0);\n  border-radius: 100%;\n  border-bottom-color: transparent;\n  -webkit-animation: spinner 1s linear 0s infinite;\n  animation: spinner 1s linear 0s infinite;\n\n\n}\n.property-listbox-block  .rating-num-block .rating{\n  background-color: red;\n}\n.ItineraryList-block .bottom_line h1{\n  \n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 20px;\n}\n\n.ItineraryList-block .bottom_line .btn{\n    background: #e43226;\n    color: #ffffff;\n    \n    font-size: 15px;\n    border-radius: 20px !important;\n    padding: 4px 30px;\n    font-weight: 500;\n    margin-right: 15px;\n    margin-top: 70px;\n    text-transform: uppercase;\n    border: 2px solid #e43226;\n}\n.ItineraryList-block .bottom_line .btn:hover{\n  background: #fff;\n  color: #e43226;\n  transition: All 0.5s;\n}\n.sch_appointments_thumbs.viewmore .item{ box-shadow: none; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
